export default class TestCategory {
    constructor() {
        this.name = '';
        this.description = '';
        this.hidden = false;
        this.tests = [];
    }
}
